import WebGalleryPhotoViewerActions from './WebGalleryPhotoViewerActions';

export default WebGalleryPhotoViewerActions;
